module.exports = __webpack_public_path__ + "img/section1_starburst_desktop.f7906c2f.svg";